import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import dashboardIcon from '../../assets/images/SideIcons/icn-dashboard.svg';
import aiIcon from '../../assets/images/SideIcons/icn-ai-sparkle.svg';
import financesIcon from '../../assets/images/SideIcons/icn-finances.svg';
import settingsIcon from '../../assets/images/SideIcons/icn-settings.svg';
import graphIcon from '../../assets/images/chart-arrow-grow.svg';
import claimIcon from '../../assets/images/box.svg';
import payIcon from '../../assets/images/Pay.png'; 
import securityIcon from '../../assets/images/SideIcons/icn-staff.svg';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { version } from '../../../package.json';
import { build } from '../../build.json';
import { userHasPermission } from '../../utils/helpers';
import { USER_PERMISSIONS } from 'store/enums';
import { url } from 'services/router-service';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export class AppMenu extends Component {
    canAccessAI() {
        if (userHasPermission("AI System Designer")) return true;

        // 1. Grab the parent nested user info profile block
        const userInfoStr = localStorage.getItem("userInfo");
        if (!userInfoStr) return false;

        try {
            // 2. Safely unpack the profile structure
            const userInfo = JSON.parse(userInfoStr);
            const perms = userInfo?.permissions;

            // 3. Ensure the inner array exists before executing the scan string match
            if (!Array.isArray(perms)) return false;

            return perms.some(p => typeof p === 'string' && p.startsWith("AI_TOOL_"));
        } catch (e) {
            // Defensive boundary check if JSON serialization ever breaks
            console.error("Failed to evaluate user permission structures.", e);
            return false;
        }
    }

    state = { 
        activeItem: userHasPermission("Access Dashboard") ? 'dashboard' : 'claims',
        isCollapsed: false
    }

    toggleSidebar = () => {
        const { isCollapsed } = this.state;
        this.setState({ isCollapsed: !isCollapsed });
        document.body.classList.toggle('sidebar-collapsed', !isCollapsed);
    }

    setActive(name) {
        this.setState({ activeItem: name });
    }

    render() {
        const { activeItem, isCollapsed } = this.state;
        const showAI = this.canAccessAI();

        return (
            <div className={`sidebar-menu-container ${isCollapsed ? 'collapsed' : ''}`}>
                <div className="sidebar-toggle-wrapper" onClick={this.toggleSidebar}>
                    <div className="sidebar-toggle-handle">
                        {isCollapsed ? <FaChevronRight size={10} /> : <FaChevronLeft size={10} />}
                    </div>
                </div>

                <div className="sb-content-mask">
                    <div className="sb-inner-list">
                        {userHasPermission("Access Dashboard") && (
                            <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-dashboard">Dashboard</Tooltip>}
                                /* Disable the tooltip if the sidebar is expanded */
                                trigger={isCollapsed ? ['hover', 'focus'] : []}
                            >
                                <Link to="/" className={`sb-item ${activeItem === 'dashboard' ? 'active' : ''}`} onClick={() => this.setActive('dashboard')}>
                                    <img className="sb-icon" src={dashboardIcon} alt="dashboard" />
                                    {!isCollapsed && <span className="sb-text">Dashboard</span>}
                                </Link>
                            </OverlayTrigger>
                        )}

                        <OverlayTrigger
                            placement="right"
                            overlay={<Tooltip id="tooltip-claims">Claims</Tooltip>}
                            /* Disable the tooltip if the sidebar is expanded */
                            trigger={isCollapsed ? ['hover', 'focus'] : []}
                        >
                            <Link to="/claims" className={`sb-item ${activeItem === 'claims' ? 'active' : ''}`} onClick={() => this.setActive('claims')}>
                                <img className="sb-icon" src={claimIcon} alt="claims" />
                                {!isCollapsed && <span className="sb-text">Claims</span> }
                            </Link>
                        </OverlayTrigger>

                        {userHasPermission("Access Financials") && (
                            <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-financials">Financials</Tooltip>}
                                /* Disable the tooltip if the sidebar is expanded */
                                trigger={isCollapsed ? ['hover', 'focus'] : []}
                            >
                                <Link to="/financials" className={`sb-item ${activeItem === 'financials' ? 'active' : ''}`} onClick={() => this.setActive('financials')}>
                                    <img className="sb-icon" src={financesIcon} alt="financials" />
                                    {!isCollapsed && <span className="sb-text">Financials</span> }
                                </Link>
                            </OverlayTrigger>
                        )}

                        {userHasPermission(USER_PERMISSIONS.PAYROLL_CAN_ACCESS) && (
                            <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-payroll">Payroll</Tooltip>}
                                /* Disable the tooltip if the sidebar is expanded */
                                trigger={isCollapsed ? ['hover', 'focus'] : []}
                            >
                                <Link to="/payroll" className={`sb-item ${activeItem === 'payroll' ? 'active' : ''}`} onClick={() => this.setActive('payroll')}>
                                    <img className="sb-icon" src={payIcon} style={{ height: '24px', width: 'auto' }} alt="payroll" />
                                    {!isCollapsed && <span className="sb-text">Payroll</span> }
                                </Link>
                            </OverlayTrigger>
                        )}

                        {userHasPermission("Access Reports") && (
                            <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-reports">Reports</Tooltip>}
                                /* Disable the tooltip if the sidebar is expanded */
                                trigger={isCollapsed ? ['hover', 'focus'] : []}
                            >
                                <a href="https://reports.compassadjusters.com:8443/Reports" target="_blank" rel="noopener noreferrer" className="sb-item">
                                    <img className="sb-icon" style={{filter: 'brightness(0) invert(1)'}} src={graphIcon} alt="reports" />
                                    {!isCollapsed && <span className="sb-text">Reports</span> }
                                </a>
                            </OverlayTrigger>
                        )}

                        {userHasPermission("Access Settings") && (
                            <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-settings">Settings</Tooltip>}
                                /* Disable the tooltip if the sidebar is expanded */
                                trigger={isCollapsed ? ['hover', 'focus'] : []}
                            >
                                <Link to="/admin" className={`sb-item ${activeItem === 'admin' ? 'active' : ''}`} onClick={() => this.setActive('admin')}>
                                    <img className="sb-icon" src={settingsIcon} alt="settings" />
                                    {!isCollapsed && <span className="sb-text">Settings</span> }
                                </Link>
                            </OverlayTrigger>
                        )}

                        {userHasPermission("Security Administrator") && (
                            <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-security">Security</Tooltip>}
                                /* Disable the tooltip if the sidebar is expanded */
                                trigger={isCollapsed ? ['hover', 'focus'] : []}
                            >
                                <Link to="/security" className={`sb-item ${activeItem === 'security' ? 'active' : ''}`} onClick={() => this.setActive('security')}>
                                    <img className="sb-icon" src={securityIcon} alt="security" />
                                    {!isCollapsed && <span className="sb-text">Security</span> }
                                </Link>
                            </OverlayTrigger>
                        )}

                        {showAI && (
                            <OverlayTrigger
                                placement="right"
                                overlay={<Tooltip id="tooltip-ai">Comtrack AI</Tooltip>}
                                /* Disable the tooltip if the sidebar is expanded */
                                trigger={isCollapsed ? ['hover', 'focus'] : []}
                            >
                                <Link to={url.aiLab} className={`sb-item ${activeItem === 'ai-lab' ? 'active' : ''}`} onClick={() => this.setActive('ai-lab')}>
                                    <img className="sb-icon" src={aiIcon} alt="ai" />
                                    {!isCollapsed && <span className="sb-text">Comtrack AI</span> }
                                </Link>
                            </OverlayTrigger>
                        )}
                    </div>

                    {!isCollapsed && (
                        <div className="sb-footer">
                            {version} build {build}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}